import { applicationUserManager } from '@/applicationUserManager'
const axios = require('axios')
const env = process.env.VUE_APP_ENV
const isDevelopment = env === 'Development'


export async function searchClient(config, lazy){
	// Show data on local development environment
	if(isDevelopment){
		return new Promise(async (resolve)=>{
			console.info('Get test data with config:', config)
			let data
			if(lazy){
				data = await import('./../json/ncSearch.lazy.json')
			}else{
				data = await import('./../json/ncSearch.json')
			}
			
			// change random brand to be active, so reactivity can be checked
			data.result.facets[0].facets[Math.round(Math.random()*10)].isSelected = true
			setTimeout(()=>{
				resolve({data})
			},1000)
		})
	}

	let user
	try {
		if (process.env.VUE_APP_ENABLE_LOGIN === 'true') {
			user = await applicationUserManager.getUser()
			if (!user) {
				await applicationUserManager.login()
				return
			}
		}
	} catch (e) {
		console.error(e)
	}

	return axios({
		method: 'post',
		url: config.query,
		headers: {
			authorization: 'Bearer ' + user.access_token,
			'x-environment': env,
			'x-version': window.appVersion
		},
		data: config.body,
	}).catch(error =>{
		console.error(error)
	})
}
